/* ATENEA · Días Morados — reloj de cuenta regresiva.
   Vanilla, sin dependencias. Lee data-fin-s (epoch en segundos, desde el metafield dm_fin).
   Al llegar a cero: muestra el estado "ya terminaron" o esconde la sección, según data-al-terminar. */
if (!customElements.get('moldeamos-dm-reloj')) {
  customElements.define(
    'moldeamos-dm-reloj',
    class MoldeamosDmReloj extends HTMLElement {
      connectedCallback() {
        this.fin = Number(this.dataset.finS) * 1000;
        if (!this.fin) return;
        this.d = this.querySelector('[data-dm-d]');
        this.h = this.querySelector('[data-dm-h]');
        this.m = this.querySelector('[data-dm-m]');
        this.s = this.querySelector('[data-dm-s]');

        const fecha = this.querySelector('[data-dm-fecha]');
        if (fecha) {
          try {
            const txt = new Intl.DateTimeFormat('es-CO', {
              day: 'numeric',
              month: 'long',
              timeZone: 'America/Bogota',
            }).format(new Date(this.fin));
            fecha.textContent = 'Hasta el ' + txt;
          } catch (e) {
            /* sin Intl: se queda solo el reloj */
          }
        }

        this.tic();
        this.timer = setInterval(() => this.tic(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      dos(n) {
        return (n < 10 ? '0' : '') + n;
      }

      tic() {
        const resto = this.fin - Date.now();
        if (resto <= 0) {
          clearInterval(this.timer);
          this.terminar();
          return;
        }
        const seg = Math.floor(resto / 1000);
        this.d.textContent = this.dos(Math.floor(seg / 86400));
        this.h.textContent = this.dos(Math.floor((seg % 86400) / 3600));
        this.m.textContent = this.dos(Math.floor((seg % 3600) / 60));
        this.s.textContent = this.dos(seg % 60);
      }

      terminar() {
        const hero = this.closest('[data-dm-hero]');
        if (!hero) return;
        const activa = hero.querySelector('[data-dm-activa]');
        const fuera = hero.querySelector('[data-dm-fuera]');
        if (activa) activa.hidden = true;
        if (hero.dataset.alTerminar === 'mensaje' && fuera) {
          fuera.hidden = false;
        } else {
          hero.hidden = true;
        }
      }
    }
  );
}
